import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <div md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            Passionate and results-driven <i>

                <b className="purple">AI and ML Engineer   </b>
              </i> with hands-on experience in building intelligent systems and ensuring software quality.<i><p className="purple">Proficient in C, C++, Java, JavaScript, and Python, with practical expertise in tools like TensorFlow, Google Colab, React, Node.js, Postman, and RestAssured.</p></i> 
              <br/>

Skilled in both development and testing, I bring a strong eye for detail, a problem-solving mindset, and a commitment to continuous learning. Known for strong leadership, effective team collaboration, and the ability to thrive in fast-paced, innovative environments.
              <br />
              
            </p>
          </div>

          <Row>
          <Col id ="contact" md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ishnoor.s2"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ishnoor-singh-0983b134a/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              
            </ul>
          </Col>
        </Row>
         
        </Row>
        
      </Container>
    </Container>
  );
}
export default Home2;
